import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Like from 'components/Like';
import Subscribe from 'components/Subscribe';
import withStyles from 'decorators/withStyles';
import cx from './SpecialGoalCard.scss';

@withStyles(cx)
export default class SpecialGoalCard extends React.Component {

  static propTypes = {
    goal: ImmutablePropTypes.map.isRequired,
    onUnsubscribe: PropTypes.func,
    onSubscribe: PropTypes.func,
    onLike: PropTypes.func,
  };

  render() {
    const { goal, onUnsubscribe, onSubscribe, onLike } = this.props;

    const itemProps = {
      style: {
        backgroundImage: `url(${goal.get('img')})`,
        backgroundColor: goal.get('imgBg'),
      },
      className: cx('item'),
      key: goal.get('id'),
    };

    return (
      <div {...itemProps}>
        <a href={goal.get('url')} className={cx('link')} />

        <h3 className={cx('title')}>
          <span dangerouslySetInnerHTML={{ __html: goal.get('name') }} />
        </h3>

        <div className={cx('actions')}>
          {Number(goal.get('is_own')) === 0 &&
            <Subscribe
              subscribed={parseInt(goal.get('subscription'), 10) > 0}
              counter={Number(goal.get('count_subscriptions'))}
              onClick={Number(goal.get('subscription')) > 0 ? onUnsubscribe : onSubscribe}
              />
          }

          <Like
            liked={goal.get('liked')}
            disabled={goal.get('is_own') > 0}
            counter={parseInt(goal.get('rating'), 10)}
            onClick={onLike}
            />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/react/components/SpecialGoalCard/SpecialGoalCard.js